<template>
  <div class="d-flex flex-wrap  align-items-center py-2">
    <div class="d-flex flex-wrap align-items-center">
      <!-- <div class="input-group input-group-solid mr-3 mb-2" style="width: 251px">
        <input
          type="text"
          class="form-control"
          placeholder="输入编码或名称搜索..."
          v-model.trim="searchValue"
          @keyup.enter="$emit('keyup-enter')"
        />
        <div class="input-group-append">
          <span class="input-group-text">
            <vi-icon name="fas:search" />
          </span>
        </div>
      </div> -->
      <div class="input-group" v-if="!search.hidden">
        <input
          type="text"
          class="form-control"
          :placeholder="search.placeholder"
          v-model.trim="searchValue"
          @keyup.enter="$emit('keyup-enter')"
        />
        <div class="input-group-append">
          <span class="input-group-text"> <vi-icon name="fas:search"/></span>
        </div>
      </div>
      
    </div>
    <slot name="append"></slot>
  </div>
</template>
<script>
export default {
  name: "VcDatatableSearch",
  data() {
    return {};
  },
  props: {
    value: [String, Number],
    advanced: Boolean,
    fields: {
      type: Array,
      default: () => [],
    },
    advancedValue: {
      type: Object,
      default: () => {},
    },
    search: {
      type: Object,
      default: function() {
        return {
          hidden: false,
          placeholder: "输入编码或名称搜索..",
        };
      },
    },
  },
  computed: {
    searchValue: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
      },
    },
  },
  mounted() {
    this.eInit();
  },
  methods: {
    eInit() {
      this.eSetArgs();
    },
    eSetArgs() {
      this.fields.map((col) => {
        if (!col.range || col.range.length === 0) {
          this.$set(this.advancedValue, col.field, null);
        } else {
          col.range.map((item) => {
            this.$set(this.advancedValue, item.field, null);
          });
        }
      });
    },
    eReset() {
      this.$emit("e-reset");
    },
    eSearch() {
      this.$emit("e-search");
    },
  },
};
</script>
<style>
.input-group{
  width: unset !important;
}
</style>
